import React, { ReactElement, useCallback, useEffect, useMemo, useState } from "react";

import { Checkbox, Loader } from "semantic-ui-react";

import moment from "moment";
import { momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useIntl } from "react-intl";

import SnackMessage from "react-lib/apps/common/SnackMessage";

import { ADMIN_NAME_LIST } from "../USER/CardSettingDivision";

import CardChairUX from "./CardChairUX";
import CardSelectTemplate from "./CardSelectTemplate";
import { blockListForChair } from "./common/BlockList";
import ModChairDetail from "./ModChairDetail";
import ZoneSelector from "./ZoneSelector";

import { CHAIR_STATUS } from "./SchedulingInterface";

import { formatISOToFullBEDate } from "react-lib/utils/dateUtils";

console.log("initial moment locale en week dow 1")
moment.updateLocale("en", { week: { dow: 1 } });
const localizer = momentLocalizer(moment);
const CARD_CHAIR = "CardChair";

const ACTION_SEARCH = `${CARD_CHAIR}_SEARCH`;

const CardChair = (props: any) => {
  const intl = useIntl();
  const [mode, setMode] = useState("home");
  const [chairList, setChairList] = useState<any[]>([]);
  const [zone, setZone] = useState<any>(null);
  const [selectedChair, setSelectedChair] = useState<any>(null);
  const [chairProviderIdList, setChairProviderIdList] = useState<number[]>([]);
  const [selectedDivision, setSelectedDivision] = useState<any>(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);

  const [filterChairNo, setFilterChairNo] = useState<string>("");
  const [filterStatus, setFilterStatus] = useState<string>("");
  const [filterClinic, setFilterClinic] = useState<string>("");

  const [calendarYear, setCalendarYear] = useState<string[]>([moment().format("YYYY")]);

  const [timePeriodSelected, setTimePeriodSelected] = useState<string>("");
  const [dateSelected, setDateSelected] = useState<string>("");
  const [chairBookingId, setChairBookingId] = useState<number>();

  useEffect(
    () => () => {
      props.setProp("blockDateFilter", null);
    },
    []
  );

  useEffect(() => {
    props.onEvent({ message: "GetChairList", params: { btnAction: ACTION_SEARCH } });
    props.onEvent({
      message: "SetScheduling",
      params: {
        action: "GetScheduleTemplate",
      },
    });
  }, [props.selectedDivision?.id]);

  useEffect(() => {
    if (props.chairList?.length > 0 && selectedDivision?.name) {
      setFilterClinic(selectedDivision?.name)
      setFilterStatus(CHAIR_STATUS[1])
    }
  }, [props.chairList, selectedDivision?.name])

  useEffect(() => {
    if (!selectedDivision) {
      props.setProp("blockList", []);
      props.setProp("holiday", []);

      return;
    }

    props.onEvent({
      message: "FilterSchedule",
      params: {
        divisionId: selectedDivision?.id,
        initial: false,
        isPreserveDivision: true,
        isRefresh: true,
      },
    });
    props.onEvent({
      message: "Holiday",
      params: { action: "refresh", divisionId: selectedDivision?.id },
    });

    setChairProviderIdList([]);
  }, [selectedDivision]);

  useEffect(() => {
    let chairList: any[] = [];
    if (props.chairList?.length > 0) {
      chairList = [...props.chairList];
      if (filterChairNo) {
        chairList = chairList.filter((item: any) => item.name?.includes(filterChairNo));
      }
      if (filterStatus) {
        chairList = chairList.filter((item: any) => item.status_name ===filterStatus);
      }
      if (filterClinic) {
        chairList = chairList.filter((item: any) => item.division_name?.includes(filterClinic));
      }
    }
    console.log(" status_name", chairList, filterStatus);

    updateChairList(chairList);
  }, [props.chairList, filterChairNo, filterClinic, filterStatus]);

  useEffect(() => {
    // if (chairProviderIdList?.length) {
      props.onEvent({
        message: "FilterSchedule",
        params: {
          providerId: chairProviderIdList,
        },
      });
    // }
    updateChairList(chairList);
  }, [chairProviderIdList]);

  const divisionOptions = useMemo(
    () => props.adminMenuDivisions?.all[ADMIN_NAME_LIST.บริหารเก้าอี้]?.divisions || [],
    [props.adminMenuDivisions]
  );

  useEffect(() => {
    const divisionId =
      props.adminMenuDivisions?.all[ADMIN_NAME_LIST.บริหารเก้าอี้]?.ids[
        props.selectedDivision?.id
      ] || null;
    const division = divisionOptions.find((div: Record<string, any>) => div.value === divisionId);

    setSelectedDivision(division?.original || null);
  }, [props.selectedDivision?.id]);

  // Memo callback
  const chairDetailData = (selectedEvent?.open_chairs || [])
    .concat(selectedEvent?.booked_chairs || [])
    ?.map((item: any) => ({
      ...item,
      chair_status: item.chair_status === 2 ? "ปิดให้บริการ" : "เปิดให้บริการ",
    }));

    // Callback
  const handlePrintReport = useCallback(() => {
    props.onEvent({
      message: "HandlePrintChairBooking",
      params: {
        booked: chairDetailData,
        date: dateSelected,
        dsb: chairBookingId,
        period: timePeriodSelected,
        providers: selectedEvent?.providers,
      },
    });
  }, [chairBookingId, chairDetailData, dateSelected, selectedEvent, timePeriodSelected]);

  const handleCloseModChair = useCallback(() => {
    setOpenModal(false);
  }, []);

  // Memo
  const createOptions = (value: string, idx: number) => ({ key: idx+1, value, text: value });

  const chairNoOptions = useMemo(() => {
    return (props.chairList || []).map((item: any) => ({key: item.id, value: item.id, text: item.name}))
    // return Array.from(new Set(props.chairList || []))
    //   .map((item: any) => item.name)
    //   .map((item: any, index: number) => createOptions(item, index));
  }, [props.chairList]);

  const statusOptions = useMemo(() => {
    return [...Object.values(CHAIR_STATUS), "กำลังใช้งาน", "ปิดซ่อม"].map(createOptions);
  }, [props.chairList]);

  const clinicOptions = useMemo(() => {
    console.log("clinicOptions props.divisionDict: ", props.divisionDict)
    return Array.from(new Set(Object.values(props.divisionDict || {})))
      .map((item: any) => item.name)
      .map(createOptions);
  }, [props.chairList]);

  // console.log("props.chairList", chairNoOptions, statusOptions, clinicOptions);
  // console.log('CardChair clinicOptions: ', clinicOptions);
  // console.log('CardChair statusOptions: ', statusOptions);
  // console.log('CardChair chairNoOptions: ', chairNoOptions);
  // console.log('CardChair selectedEvent: ', selectedEvent);

  const updateChairList = (items: any[]) => {
    setChairList(
      items.map((chair: any) => ({
        ...chair,
        select: (
          <Checkbox
            checked={chairProviderIdList.includes(chair?.provider)}
            onClick={(e: any) => {
              e.stopPropagation();
              if (chairProviderIdList.includes(chair?.provider)) setChairProviderIdList(chairProviderIdList.filter((id: number) => id !== chair?.provider));
              else setChairProviderIdList([...chairProviderIdList, chair?.provider]);
            }}
          />
        ),
      }))
    );
  };

  const blockStyle = (event: any) => {
    if (selectedChair) {
      // Issue 55924
      return event?.holiday
        ? { backgroundColor: "#ffe696", color: "black", textAlign: "center" }
        : event?.division_id !== selectedDivision?.id
        ? { backgroundColor: "orange", color: "black" }
        : event?.open_chairs.map((chair: any) => chair.provider_id).includes(selectedChair?.provider)
        ? { backgroundColor: "cyan", color: "black" }
        : event?.booked_chairs.map((chair: any) => chair.provider_id).includes(selectedChair?.provider)
        ? { backgroundColor: "#cccccc", color: "black" }
        : { backgroundColor: "pink", color: "black" };
    } else {
      // Issue 55924
      return event?.holiday
        ? { backgroundColor: "#ffe696", color: "black", textAlign: "center" }
        : event?.division_id !== selectedDivision?.id
        ? { backgroundColor: "orange", color: "black" }
        : event?.open_chairs.length > 0
        ? { backgroundColor: "cyan", color: "black" }
        : event?.booked_chairs.length > 0
        ? { backgroundColor: "#cccccc", color: "black" }
        : { backgroundColor: "pink", color: "black" };
    }
  };

  const filterChairsByProviderIds = (items: any[] = []): string[] => {
    const providerIds = new Set<number>(items.map((item) => item.provider as number));

    return chairList
      .filter((item) => providerIds.has(item.provider))
      .map((item) => item.name as string);
  };

  const getMessageStatus = (duplicateChairNames: string[], successChairNames: string[]): string => {
    if (duplicateChairNames.length > 0 && successChairNames.length > 0) {
      return "warning";
    }

    if (duplicateChairNames.length > 0) {
      return "error";
    }

    if (successChairNames.length > 0) {
      return "success";
    }

    return "";
  };

  const blockList = useMemo(() => {
    let blockListSet = props.blockList.concat(
      props.providerBlockList?.filter((item: any) => item.division_id !== selectedDivision?.id) ||
        []
    );
    let bl = blockListForChair(
      blockListSet,
      selectedChair,
      zone,
      props.allDivisionDict,
      props.chairList,
      selectedDivision
    );
    // console.log('blockList useMemo bl: ', bl);
    return bl;
  }, [
    props.blockList,
    selectedChair,
    zone,
    props.allDivisionDict,
    props.chairList,
    props.providerBlockList,
    selectedDivision,
  ]);

  const blockListAndHoliday = useMemo(() => {
    const holiday = (props.holiday?.items || []).flatMap((item: any) => {
      const [day, month, year] = item.date[0].split("/");
      const date = `${year - 543}-${month}-${day}`;
      return { start: new Date(`${date} 00:00`), end: new Date(`${date} 23:59`), title: item.detail, holiday: true };
      // return calendarYear.map((year) => {
      //   const date = `${year}-${month}-${day}`;
      //   return { start: new Date(`${date} 00:00`), end: new Date(`${date} 23:59`), title: item.detail, holiday: true };
      // });
    });

    return [...holiday , ...blockList ];
  }, [calendarYear, blockList, props.holiday?.items]);

  const selectedChairText = useMemo(
    () =>
      chairList
        .filter((chair: any) => chairProviderIdList.includes(chair.provider))
        .map((chair: any) => chair?.name)
        .join(", "),
    [chairProviderIdList, chairList]
  );

  const chairAlertMessage = useMemo(() => {
    const message = props.successMessage?.[CARD_CHAIR];

    const duplicateChairNames = filterChairsByProviderIds(message?.duplicates);
    const updatedChairNames = filterChairsByProviderIds(message?.updated);
    const createdChairNames = filterChairsByProviderIds(message?.created);
    const successChairNames = [...createdChairNames, ...updatedChairNames].filter(
      (name) => !duplicateChairNames.includes(name)
    );

    const status = getMessageStatus(duplicateChairNames, successChairNames);

    const contentMapping: Record<string, ReactElement> = {
      error: (
        <div style={{ textAlign: "center" }}>
          <div>{intl.formatMessage({ id: "บริหารเก้าอี้ไม่สำเร็จ" })}</div>
          <div style={{ fontWeight: "normal" }}>{intl.formatMessage({ id: "เนื่องจากรายการเก้าอี้ถูกใช้งานที่แผนกอื่นแล้ว" })}</div>
          <div style={{ fontWeight: "normal" }}>{duplicateChairNames.join(", ")}</div>
        </div>
      ),
      success: <div style={{ textAlign: "center" }}>{intl.formatMessage({ id: "บริหารเก้าอี้สำเร็จ" })}</div>,
      warning: (
        <>
          <div style={{ color: "#b58105", paddingLeft: "1.5rem" }}>
            ไม่สามารถบริหารเก้าอี้ที่เลือกทั้งหมดได้
          </div>
          <ul style={{ margin: "0.25rem 0 0 -1.5rem" }}>
            <li style={{ color: "#2c662d" }}>
              <div>{intl.formatMessage({ id: "เก้าอี้ที่บริหารสำเร็จ" })}</div>
              <div>{successChairNames.join(", ")}</div>
            </li>
            <li style={{ color: "#9f3a38" }}>
              <div>{intl.formatMessage({ id: "เก้าอี้ที่บริหารไม่สำเร็จ" })}</div>
              <div>{duplicateChairNames.join(", ")}</div>
            </li>
          </ul>
        </>
      ),
    };

    const content = contentMapping[status];

    return {
      [status]: " ",
      header: <div style={{ lineHeight: 1.75 }}>{content}</div>,
    };
  }, [chairList, props.successMessage]);

  // 2024-05-29 -> พุธที่ 29 พฤษภาคม 2567
  const formatDateLocale = (date: string) => {
    if (props.languageUX === "th") {
      return formatISOToFullBEDate(date,"ที่")
    } else {
      return moment(date).format("dddd D MMMM YYYY")
    }
  }

  // const formatDateLocale = (date: string) => {
  //   moment.updateLocale("th", null);
  //   const formattedDate = moment(date).format("ddddที่ D MMMM YYYY");
  //   const buddhistYear = moment(date).year()+ 543;
  //   return formattedDate.replace(moment(date).year().toString(), buddhistYear.toString());
  // }

  // console.log("CardChair props.providerBlockList: ", props.providerBlockList);
  // console.log("CardChair props: ", props);

  // console.log("Yeti Chair All Props: ", props);
  // console.log("Yeti Format Date: ", formatDateLocale("2024-04-29"))
  return (
    <div>
      <SnackMessage
        onEvent={props.onEvent}
        error={chairAlertMessage.error}
        header={chairAlertMessage.header}
        success={chairAlertMessage.success}
        warning={chairAlertMessage.warning}
        onClose={() => {
          props.setProp(`successMessage.${CARD_CHAIR}`, null);
        }}
        languageUX={props.languageUX}
      />

      <CardChairUX
        filterChairNo={filterChairNo}
        filterStatus={filterStatus}
        filterClinic={filterClinic}
        chairNoOptions={chairNoOptions}
        divisionOptions={divisionOptions}
        statusOptions={statusOptions}
        selectedDivisionId={selectedDivision?.id || ""}
        clinicOptions={clinicOptions}
        onChangeDivision={(e: any, v: any) => {
          const division = divisionOptions.find(
            (div: Record<string, any>) => div.value === v.value
          );

          setSelectedDivision(division?.original || null);
        }}
        onChangeFilterChairNo={(e: any, { value }: any) => {
          setFilterChairNo(value);
        }}
        onChangeFilterStatus={(e: any, { value }: any) => {
          setFilterStatus(value);
        }}
        onChangeFilterClinic={(e: any, { value }: any) => {
          console.log("onChangeFilterClinic value: ", value);
          setFilterClinic(value);
        }}
        mode={mode}
        // Chair
        selectChair={(e: any) => setMode("chair")}
        clearChair={(e: any) => {
          setChairProviderIdList([]);
          setMode("home");
        }}
        selectedChairs={selectedChairText}
        chairList={chairList}
        rowProps={(state: any, rowInfo: any, column: any, instance: any) => {
          return {
            style: {
              backgroundColor:
                rowInfo?.original?.id && rowInfo?.original?.id === selectedChair?.id
                  ? "#cccccc"
                  : "white",
            },
            onClick: () => {
              console.log("onClick rowInfo?.original", rowInfo?.original);
              if (selectedChair && rowInfo?.original?.id === selectedChair?.id)
                setSelectedChair(null);
              else setSelectedChair(rowInfo?.original);
            },
          };
        }}
        selectChairFinish={(e: any) => setMode("home")}
        selectChairClear={(e: any) => setMode("home")}
        zoneSelector={
          <ZoneSelector
            disabled={!selectedDivision?.id}
            selectedDivision={selectedDivision}
            zone={zone}
            setZone={setZone}
          />
        }
        // SelectTemplate
        cardSelectTemplate={
          <CardSelectTemplate
            readonly={!selectedDivision?.id}
            scheduleTemplates={props.scheduleTemplates}
            disableCreate={chairProviderIdList.length === 0}
            createDSBFromTemplateItems={(
              templateItems: any[],
              templateItemIndexList: number[],
              startDateTime: string,
              endDateTime: string,
              card: string,
              buttonLoadKey: string
            ) =>
              props.onEvent({
                message: "SetScheduling",
                params: {
                  action: "CreateDSBFromTemplateItems",
                  items: templateItems.filter((item: any, index: number) =>
                    templateItemIndexList.includes(index)
                  ),
                  startDateTime: startDateTime,
                  endDateTime: endDateTime,
                  providers: chairProviderIdList,
                  zone: zone,
                  chair: null,
                  capacity: null,
                  card: card,
                  buttonLoadKey: buttonLoadKey,
                  divisionId: selectedDivision?.id,
                },
              })
            }
            chairOptions={[]}
            defaultChair={null}
            defaultCapacity={null}
            zone={zone}
            selectedDivision={selectedDivision}
            buttonLoadCheck={props.buttonLoadCheck}
            setProp={props.setProp}
            card={CARD_CHAIR}
            selectedChairText={selectedChairText}
            hideExceptNewPatient={true}
            languageUX={props.languageUX}
          />
        }
        loader={props.buttonLoadCheck?.[ACTION_SEARCH] ? <Loader active> </Loader> : null}
        calendarLoader={
          props.blockLoadingFilter ? (
            <Loader style={{ left: "15.6rem", top: "2.85rem" }} size="mini" active />
          ) : null
        }
        // Calendar
        localizer={localizer}
        minTime={new Date(1972, 0, 1, 8, 0, 0)}
        maxTime={new Date(1972, 0, 1, 20, 0, 0)}
        blockList={blockListAndHoliday}
        eventPropGetter={(event: any, start: Date, end: Date, isSelected: boolean) => {
          return { style: blockStyle(event) };
        }}
        onRangeChange={(range: any, view: any) => {
          const year = Array.isArray(range)
            ? [range[0], range.slice(-1)[0]]
            : [range.start, range.end];
          const uniqueYear = Array.from(
            new Set([moment(year[0]).format("YYYY"), moment(year[1]).format("YYYY")])
          );
          if (uniqueYear.toString() !== calendarYear.toString()) {
            setCalendarYear(uniqueYear);
          }
        }}
        onSelectEvent={(event: any) => {
          console.log("event: ", event);
          if (event?.holiday) {
            return;
          }

          setDateSelected(formatDateLocale(event.date));
          setTimePeriodSelected(`เวลา ${event.start_time} - ${event.end_time} น.`);
          setChairBookingId(event.dsb_id);
          setSelectedEvent(event);
          setOpenModal(true);
        }}
        onNavigate={(date) => {
          props.onEvent({
            message: "GetBlockListFilter",
            params: { date, divisionId: selectedDivision?.id },
          });
        }}
        languageUX={props.languageUX}
      />

      <ModChairDetail
        setProp={props.setProp}
        chairDetailData={chairDetailData}
        dateSelected={dateSelected}
        open={openModal}
        timePeriodSelected={timePeriodSelected}
        buttonLoadCheck={props.buttonLoadCheck}
        onClose={handleCloseModChair}
        onPrintReport={handlePrintReport}
        languageUX={props.languageUX}
      />
    </div>
  );
};

export default CardChair;
